import { cn } from '@/lib/utils';

type IndexMarkProps = {
  compact?: boolean;
  className?: string;
  /** Wordmark colour — dark backgrounds use white (default). */
  theme?: 'dark' | 'light';
};

export default function IndexMark({ compact = false, className, theme = 'dark' }: IndexMarkProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <span
        className="inline-block shrink-0 border border-index-accent bg-black"
        style={{ width: compact ? 14 : 18, height: compact ? 14 : 18 }}
        aria-hidden
      >
        <span
          className="block m-[3px] bg-index-accent"
          style={{
            width: compact ? 6 : 8,
            height: compact ? 6 : 8,
          }}
        />
      </span>
      {!compact && (
        <span
          className={cn(
            'text-sm font-sans font-semibold uppercase tracking-[0.15em]',
            theme === 'light' ? 'text-text-dark' : 'text-white',
          )}
        >
          Nuclius Index
        </span>
      )}
    </div>
  );
}
